import { render } from "./management.cattle.io.projectroletemplatebinding.vue?vue&type=template&id=25392153&scoped=true"
import script from "./management.cattle.io.projectroletemplatebinding.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.projectroletemplatebinding.vue?vue&type=script&lang=js"

import "./management.cattle.io.projectroletemplatebinding.vue?vue&type=style&index=0&id=25392153&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25392153"]])

export default __exports__